import { Component, Inject, OnInit } from "@angular/core";
import { AbstractControl, FormGroup } from "@angular/forms";
import { BehaviorSubject, Observable } from "rxjs";

import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { LgdFormControlFactory } from "@tylertech/lgd-reactive-forms";
import { Tuple } from "@tylertech/tyler-api-types";

export interface DocTypeDialogData
{
    readonly docTypes: Tuple<string, string>[];
}

@Component({
    selector: "doc-type-dialog-component",
    templateUrl: "./docTypeDialog.tmpl.html",
    styleUrls: [
        "./docTypeDialog.component.scss"
    ],
    standalone: false
})
export class DocTypeDialogComponent implements OnInit
{
    private readonly selectedTypesSubject = new BehaviorSubject<Array<Tuple<string, string>>>([]);
    readonly formGroup: FormGroup;

    constructor(
        private readonly dialogRef: MatDialogRef<DocTypeDialogComponent, Tuple<string, string> | undefined>,
        @Inject(MAT_DIALOG_DATA) private readonly data: DocTypeDialogData)
    {
        this.formGroup = new FormGroup({
            "selectedType": LgdFormControlFactory.select<Tuple<string, string>>(
                undefined,
                true,
                {
                    displayValueFn: x => x.Item1
                }),
        });
    }

    private get docTypes(): Tuple<string, string>[] { return this.data.docTypes; }
    protected get selectedTypeControl(): AbstractControl<Tuple<string, string>> { return this.formGroup.get("selectedType"); }

    get selectedTypesObservable(): Observable<Array<Tuple<string, string>>> { return this.selectedTypesSubject.asObservable(); }

    ngOnInit(): void
    {
        this.selectedTypeControl.setValue(this.docTypes[0]);
    }

    cancel(): void
    {
        this.dialogRef.close();
    }

    confirm(): void
    {
        this.dialogRef.close(this.selectedTypeControl.value);
    }
}
